import { render, staticRenderFns } from "./ilabel.vue?vue&type=template&id=7db0e035&scoped=true&"
import script from "./ilabel.vue?vue&type=script&lang=js&"
export * from "./ilabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db0e035",
  null
  
)

export default component.exports